import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { TestScenarioDTO, TestScenarioFilterDTO } from '../../../shared/interfaces';
import { ISnackbarAlert, SnackbarAlert, CardList, TextFieldInput, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter, SelectField } from '../../../shared/components';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { TestComponentDTO } from '../../../shared/interfaces/testingSphere/TestComponentDTO';
import { TestComponentFilterDTO } from '../../../shared/interfaces/testingSphere/TestComponentFilterDTO';
import { TestComponentSequence, TestComponentMaintenance, TestAttributeValue, TestExecutionListViewDialog, TestAcceptanceCriteriaViewDialog, TestDataIntegrationViewDialog } from '../..';

interface ITestComponentProps {
    data: any;
}

export const TestComponent: React.FC<ITestComponentProps> = ({ data }) => {
    const [testScenarioList, setTestScenarioList] = useState<TestScenarioDTO[]>([]);
    const [testComponentList, setTestComponentList] = useState<TestComponentDTO[]>([]);
    const [testComponentFilterDTO, setTestComponentFilterDTO] = useState<TestComponentFilterDTO>();

    const [actionExecuted, setActionExecuted] = useState(false);
    const [newRecord, setNewRecord] = useState('');
    const [selectRecord, setSelectRecord] = useState('');

    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [testExecutionListView, setTestExecutionListView] = useState('');
    const [testAcceptanceCriteiraListView, setTestAcceptanceCriteriaListView] = useState('');
    const [testDataIntegrationListtView, setTestsDataIntegrartionListView] = useState('');

    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    useEffect(() => {
        setTestComponentFilterDTO({
            ...testComponentFilterDTO,
            name: '',
            testScenarioId: data.id ?? ''
        });
        handleTestScenarioGetAllAsync();

    }, []);

    useEffect(() => {
        handleTestComponentGetAllViewAsync();
    }, [testComponentFilterDTO]);

    useEffect(() => {
        if (actionExecuted)
            handleTestComponentGetAllViewAsync();
    }, [actionExecuted]);

    const handleTestScenarioGetAllAsync = useCallback(async () => {
        const testScenarioFilterDTO: TestScenarioFilterDTO = {
            name: '',
            testPackageId: '',
        };
        GenericService.GetAllViewAsync1('testingsphere.testscenario', testScenarioFilterDTO, setActionExecuted, setLoading, setTestScenarioList, showMessage);
    }, []);

    const handleTestComponentGetAllViewAsync = useCallback(async () => {
        if (testComponentFilterDTO === undefined)
            return;
        GenericService.GetAllViewAsync1('testingsphere.testcomponent', testComponentFilterDTO, setActionExecuted, setLoading, setTestComponentList, showMessage, true);
    }, [testComponentFilterDTO]);

    const handleClearFilterClick = () => {
        setTestComponentFilterDTO({ ...testComponentFilterDTO, name: '' } as TestComponentFilterDTO);
    };

    function handleSearchClick() {
        handleTestComponentGetAllViewAsync();
    }

    const handleNew = () => {
        setNewRecord('data');
        setSelectRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView('');
        setIsOpenMaintenance(true);
    };

    const handleSelect = () => {
        setNewRecord('');
        setSelectRecord(data);
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView('');
        setIsOpenMaintenance(true);
    };

    const handleViewDetatils = (data: string) => {
        setNewRecord('');
        setSelectRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView('');
        setIsOpenMaintenance(true);

    };

    const handleDelete = (data: string) => {
        setNewRecord('');
        setSelectRecord('');
        setDeleteRecord(data);
        setEditRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView('');
        setIsOpenMaintenance(true);
    };

    const handleTestExecutionView = (data: string) => {
        setNewRecord('');
        setSelectRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView(data);
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView('');
        setIsOpenMaintenance(true);
    };

    const handleTestAcceptanceCriteriaView = (data: string) => {
        setNewRecord('');
        setSelectRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView(data);
        setTestsDataIntegrartionListView('');
        setIsOpenMaintenance(true);
    };

    const handleTestDataIntegrationView = (data: string) => {
        setNewRecord('');
        setSelectRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView(data);
        setIsOpenMaintenance(true);
    };

    const toolBarActions: IDialogActions[] = [
        // { id: 'new', text: 'New TestComponent', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
        { id: 'Select', text: 'Select TestComponent', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleSelect },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
        { id: 'viewTestExecution', toolTip: 'TestExecution', icon: 'playlist_add_check_outlined', iconColor: 'info', setAction: handleTestExecutionView },
        { id: 'viewTestAcceptanceCriteria', toolTip: 'Test Acceptance Critera', icon: 'offline_pin_outlined', iconColor: 'info', setAction: handleTestAcceptanceCriteriaView },
        { id: 'viewTestDataIntegration', toolTip: 'Test Data Integration', icon: 'low_priority_outlined', iconColor: 'info', setAction: handleTestDataIntegrationView },
    ];

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: testComponentList.length },
        { label: 'Name', value: testComponentFilterDTO?.name },
        { label: 'TestScenario', value: !data ? testScenarioList.find(x => x.id === testComponentFilterDTO?.testScenarioId)?.name : undefined },
    ];

    const columns: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'executionStatus', label: 'Execution Status', size: 1, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: false },
        { field: 'startExecutionDateTime', label: 'Start Execution', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false },
        { field: 'endExecutionDateTime', label: 'End Execution', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false },
        { field: 'elapseTime', label: 'ElapseTime', size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false },
        { field: 'orderExecution', label: 'Order Execution', size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false },
        { field: 'cycle', label: 'Cycle', size: 1, type: 'text', visible: true, isChip: true, hasFieldLine: false },
        // { field: 'feature', label: 'Feature', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },

    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title='TESTCENARIO'>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='name'
                                label='Name'
                                value={testComponentFilterDTO?.name}
                                setValue={setTestComponentFilterDTO}
                                obj={testComponentFilterDTO}
                                placeholder={'Name'}
                                maxLength={200}
                            />
                        </Grid>
                        {!data && (
                            <React.Fragment>
                                <Grid item xs={12} md={3}>
                                    <SelectField
                                        id='testScenarioId'
                                        label='TestScenario Name'
                                        value={testComponentFilterDTO?.testScenarioId}
                                        setValue={setTestComponentFilterDTO}
                                        obj={testComponentFilterDTO}
                                        valueList={testScenarioList}
                                    />
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                <CardList
                    columns={columns}
                    rows={testComponentList}
                    actions={cardActions}
                    hasChildren={true}
                    setRowExpanded={setExpandedData}
                    cardSize={12}
                    childrenTitle={'TEST ATTRIBUTE VALUE'}
                    childrenComponent={(
                        <Box width={'100%'}>
                            <TestAttributeValue data={expadedData} />
                        </Box>
                    )}
                />
                {newRecord && (
                    <TestComponentMaintenance
                        data={data.id}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        parentId={data.id ?? testComponentFilterDTO?.testScenarioId}
                    />
                )}
                {editRecord && (
                    <TestComponentMaintenance
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (<Delete
                    entity={'testingsphere.testcomponent'}
                    data={deleteRecord}
                    setIsOpenDiaglog={setIsOpenMaintenance}
                    isOpenDialog={isOpenMaintenance}
                    setActionExecuted={setActionExecuted}
                />)}
                {selectRecord && (
                    <TestComponentSequence
                        parentId={data.id}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {testExecutionListView && (
                    <TestExecutionListViewDialog
                        data={testExecutionListView}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {testAcceptanceCriteiraListView && (
                    <TestAcceptanceCriteriaViewDialog
                        data={testAcceptanceCriteiraListView}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {testDataIntegrationListtView && (
                    <TestDataIntegrationViewDialog
                        data={testDataIntegrationListtView}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
            </LayoutDashboard>
        </React.Fragment >
    );
};